(function() {

    angular
        .module('app')
        .directive('mySrc', mySrc);
    	mySrc.$inject = [];

        	function mySrc() {
			    return {
			        restrict: 'A',
			        scope: {
			            mediafile: '&'
			        },
			        link: function ( scope, elem, attrs ) {
			            elem.attr('src', scope.mediafile());
			        }
			    };
			}


})();
